<div class="loadingBox" *ngIf="!loaded">
  <img  class="pulsate" src="assets/img/hostbrand/core-logo.svg" width="300">
 </div>
 <div *ngIf="loaded">
<section class="login-main-wrapper full-height">
  <div class="container-fluid pl-0 pr-0">
     <div class="row no-gutters row justify-content-center ">
        <div *ngIf="landing" class="col-md-5 p-5 bg-dark-style authbox">
             <div class="login-main-left">
                <div class="text-center mb-5 login-main-left-header">
                   <img src="assets/img/hostbrand/playtowin.svg" width="500" class="img-fluid" alt="LOGO">
                   <span style="min-height: 30px; display: inherit;"></span>
                   <!-- <h3>3 Days FREE GAMES!!</h3>
                   <h4>Win DAILY CASH PRIZES++</h4>
                   <p>NO SKILLS  Required!!<br/><br/>
                    The MORE You PLAY, The MORE You Can WIN!!</p>
                    <p><strong>PLUS:</strong> </p>
                    <p>A MEGA Monthly CASH PRIZE!!
                    </p> -->
                   <button type="button" (click)="signUp()" class="form-control">
                    <span>Sign Up Now</span>
                  </button></div>

             </div>
          </div>
          <div *ngIf="signup" class="col-md-5 p-5 bg-dark-style authbox">
            <div class="login-main-left">
               <div class="text-center mb-2 login-main-left-header">
                                   <img src="assets/img/hostbrand/core-logo.svg" width="100" class="img-fluid" alt="LOGO">
                                   </div>
                           <form name="sample-form" #f="ngForm">
                                           <label i18n="@@Mobile Number | Mobile Number Label">Mobile number</label><br/>
                                   <international-phone-number [(ngModel)]="mobNum" (keyup)="onMobNumKeyUp($event)" placeholder="Enter phone number" i18n-placeholder="Enter Phone Number" [maxlength]="20"  [required]="true" [defaultCountry]="'za'" #phoneNumber="ngModel" name="phone_number"  [allowedCountries]="['ng', 'za','tn', 'eg', 'dz', 'kw', 'ae']"></international-phone-number>
                                   
                                    <div *ngIf="f.submitted && !phoneNumber.valid" i18n="@@Phone number is required and should be valid | Phone Number Validation Message if not accepted" class="help-block">Phone number is required and should be valid</div>
                                   
                                                   
                                          
                                                   <div class="form-group">
                                                           <label i18n="@@Name | Name Label">Name</label>
                                                           <input type="text" class="form-control" (keyup)="onNameKeyUp($event)" placeholder="">
                                                   </div>
                                           
                                           
                                                   <div class="form-group">
                                                           <label i18n="@@Email | Email Label">Email</label>
                                                           <input type="email" class="form-control" (keyup)="onEmailKeyUp($event)" placeholder="">
                                                   </div>
                                                   <div class="form-group">
                                                           <label i18n="@@Password | Password Label">Password</label>
                                                           <input minlength=6 type="password" class="form-control" (keyup)="onPasswordKeyUp($event)" placeholder="">
                                                   </div>
                                                   <div class="form-group">
                                                                   <label>Select Currency</label>
                                                                   <select class="form-control" (change)="onCurrency($event)">
                                                                                   <option disabled selected value> </option>
                                                                                   <option *ngFor="let content of currencyType, let i=index;" value="{{content.id}}">{{content.name}}</option>
                                                                           </select>
                                                                   
                                                           </div>
                                                   <div class="form-group">
                                                           <label i18n="@@Mobile Operator | Mobile Operator Label">Mobile Operator</label>
                                                           <select class="form-control" (change)="onMobOperatorChoice($event)">
                                                                   <option i18n="@@Select Mobile Operator | Select Mobile Operator Default Input" disabled selected value></option>
                                                                   <option *ngFor="let content of operatorType, let i=index;" value="{{content.id}}">{{content.name}}</option>
                                                           </select>
                                                   </div><button class="form-control">
          
                                                           <span i18n="@@Submit | Submit Button" (click)="postProfile()">Submit</span>
                                                         </button>
                                                   </form>
                   </div>
           </div>
    </div>
    </div>
 </section>
 </div>